import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => (
  <div className="page-container">
    <div className="content-container">
      <h1>Welcome to Unpager</h1>
      <p>Upload, manage, and share your files with ease</p>

      <div className="button-container">
        <Link to="/login">
          <button className="home-button">Login</button>
        </Link>
        <Link to="/register">
          <button className="home-button">Register</button>
        </Link>
        <Link to="/upload">
          <button className="home-button">Upload PDF</button>
        </Link>
      </div>
    </div>
  </div>
);

export default HomePage;
